export default "__VITE_ASSET__CQPexqg___"